import { useRef, useEffect } from 'react';

const useInterval = (callback, delay) => {
    const intervalRef = useRef();
    useEffect(() => {
        if (delay) {
            intervalRef.current = setInterval(() => {
                callback();
            }, delay);
        }
        return () => {
            clearInterval(intervalRef.current);
        };
    }, [callback, delay]);
};

export { useInterval as default };
//# sourceMappingURL=useInterval.js.map
